var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9628 20.707C37.9628 19.7848 37.2151 19.0371 36.2929 19.0371H20.707C19.7848 19.0371 19.0371 19.7848 19.0371 20.707V36.2929C19.0371 37.2151 19.7848 37.9628 20.707 37.9628H36.2929C37.2151 37.9628 37.9628 37.2151 37.9628 36.2929V20.707Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7503 18.7919C42.4025 19.444 43.4597 19.444 44.1119 18.7919L50.2524 12.6514L52.7791 15.1781C53.7692 16.1682 55.465 15.5734 55.6196 14.1817L56.9893 1.85461C57.1074 0.790983 56.2088 -0.107654 55.1451 0.0104649L42.8181 1.38013C41.4264 1.53476 40.8315 3.2305 41.8217 4.22065L44.3484 6.74734L38.2079 12.8878C37.5557 13.54 37.5557 14.5973 38.2079 15.2494L41.7503 18.7919Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38013 14.1817C1.53476 15.5734 3.2305 16.1682 4.22065 15.1781L6.74734 12.6514L12.8878 18.7919C13.54 19.444 14.5973 19.444 15.2494 18.7919L18.7919 15.2494C19.444 14.5973 19.444 13.54 18.7919 12.8878L12.6514 6.74734L15.1781 4.22065C16.1682 3.2305 15.5734 1.53476 14.1817 1.38013L1.85461 0.0104649C0.790983 -0.107654 -0.107654 0.790983 0.0104649 1.85461L1.38013 14.1817Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6196 42.8161C55.465 41.4244 53.7692 40.8296 52.7791 41.8197L50.2524 44.3464L44.1119 38.2059C43.4597 37.5538 42.4025 37.5538 41.7503 38.2059L38.2079 41.7484C37.5557 42.4005 37.5557 43.4578 38.2079 44.11L44.3484 50.2504L41.8217 52.7771C40.8315 53.7673 41.4264 55.463 42.8181 55.6177L55.1451 56.9873C56.2088 57.1056 57.1074 56.2068 56.9893 55.1433L55.6196 42.8161Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2494 38.2059C14.5973 37.5538 13.54 37.5538 12.8878 38.2059L6.74734 44.3464L4.22065 41.8197C3.2305 40.8296 1.53476 41.4244 1.38013 42.8161L0.0104649 55.1432C-0.107654 56.2068 0.790983 57.1054 1.85461 56.9872L14.1817 55.6175C15.5734 55.4629 16.1682 53.7672 15.1781 52.777L12.6514 50.2503L18.7919 44.1098C19.444 43.4577 19.444 42.4004 18.7919 41.7482L15.2494 38.2059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord31);
export default __webpack_public_path__ + "static/media/accord_31.5ae863737c3c04cf58f7e59e09ed7bf2.svg";
export { ForwardRef as ReactComponent };